import { translate as t } from '@services/l10n';

/**
 * Translations file from library source
 * We also use that to edit the end strings of
 * some buttons, like resetOperations
 *
 * @see https://raw.githubusercontent.com/scaleflex/filerobot-image-editor/v4/packages/react-filerobot-image-editor/src/context/defaultTranslations.js
 */
export default {
  name: t('memories', 'Name'),
  save: t('memories', 'Save'),
  saveAs: t('memories', 'Save as'),
  back: t('memories', 'Back'),
  loading: t('memories', 'Loading …'),
  resetOperations: t('memories', 'Reset'),
  discardChangesWarningHint: t('memories', 'Are you sure you want to discard the changes?'),
  cancel: t('memories', 'Cancel'),
  continue: t('memories', 'Continue'),
  undoTitle: t('memories', 'Undo'),
  redoTitle: t('memories', 'Redo'),
  showImageTitle: t('memories', 'Show original image'),
  zoomInTitle: t('memories', 'Zoom in'),
  zoomOutTitle: t('memories', 'Zoom out'),
  toggleZoomMenuTitle: t('memories', 'Toggle zoom menu'),
  adjustTab: t('memories', 'Adjust'),
  finetuneTab: t('memories', 'Fine-tune'),
  filtersTab: t('memories', 'Filters'),
  watermarkTab: t('memories', 'Watermark'),
  annotateTab: t('memories', 'Draw'),
  resize: t('memories', 'Resize'),
  resizeTab: t('memories', 'Resize'),
  invalidImageError: t('memories', 'Invalid image.'),
  uploadImageError: t('memories', 'Error while uploading the image.'),
  areNotImages: t('memories', 'are not images'),
  isNotImage: t('memories', 'is not an image'),
  toBeUploaded: t('memories', 'to be uploaded'),
  cropTool: t('memories', 'Crop'),
  original: t('memories', 'Original'),
  custom: t('memories', 'Custom'),
  square: t('memories', 'Square'),
  landscape: t('memories', 'Landscape'),
  portrait: t('memories', 'Portrait'),
  ellipse: t('memories', 'Ellipse'),
  classicTv: t('memories', 'Classic TV'),
  cinemascope: t('memories', 'CinemaScope'),
  arrowTool: t('memories', 'Arrow'),
  blurTool: t('memories', 'Blur'),
  brightnessTool: t('memories', 'Brightness'),
  contrastTool: t('memories', 'Contrast'),
  ellipseTool: t('memories', 'Ellipse'),
  unFlipX: t('memories', 'Un-flip X'),
  flipX: t('memories', 'Flip X'),
  unFlipY: t('memories', 'Un-flip Y'),
  flipY: t('memories', 'Flip Y'),
  hsvTool: t('memories', 'HSV'),
  hue: t('memories', 'Hue'),
  saturation: t('memories', 'Saturation'),
  value: t('memories', 'Value'),
  imageTool: t('memories', 'Image'),
  importing: t('memories', 'Importing …'),
  addImage: t('memories', '+ Add image'),
  lineTool: t('memories', 'Line'),
  penTool: t('memories', 'Pen'),
  polygonTool: t('memories', 'Polygon'),
  sides: t('memories', 'Sides'),
  rectangleTool: t('memories', 'Rectangle'),
  cornerRadius: t('memories', 'Corner Radius'),
  resizeWidthTitle: t('memories', 'Width in pixels'),
  resizeHeightTitle: t('memories', 'Height in pixels'),
  toggleRatioLockTitle: t('memories', 'Toggle ratio lock'),
  reset: t('memories', 'Reset'),
  resetSize: t('memories', 'Reset to original image size'),
  rotateTool: t('memories', 'Rotate'),
  textTool: t('memories', 'Text'),
  textSpacings: t('memories', 'Text spacing'),
  textAlignment: t('memories', 'Text alignment'),
  fontFamily: t('memories', 'Font family'),
  size: t('memories', 'Size'),
  letterSpacing: t('memories', 'Letter spacing'),
  lineHeight: t('memories', 'Line height'),
  warmthTool: t('memories', 'Warmth'),
  addWatermark: t('memories', '+ Add watermark'),
  addWatermarkTitle: t('memories', 'Choose watermark type'),
  uploadWatermark: t('memories', 'Upload watermark'),
  addWatermarkAsText: t('memories', 'Add as text'),
  padding: t('memories', 'Padding'),
  shadow: t('memories', 'Shadow'),
  horizontal: t('memories', 'Horizontal'),
  vertical: t('memories', 'Vertical'),
  blur: t('memories', 'Blur'),
  opacity: t('memories', 'Opacity'),
  position: t('memories', 'Position'),
  stroke: t('memories', 'Stroke'),
  saveAsModalLabel: t('memories', 'Save image as'),
  extension: t('memories', 'Extension'),
  nameIsRequired: t('memories', 'Name is required.'),
  quality: t('memories', 'Quality'),
  imageDimensionsHoverTitle: t('memories', 'Saved image size (width x height)'),
  cropSizeLowerThanResizedWarning: t(
    'memories',
    'Note that the selected crop area is lower than the applied resize which might cause quality decrease',
  ),
  actualSize: t('memories', 'Actual size (100%)'),
  fitSize: t('memories', 'Fit size'),
};
